import apiService from "./apiService"

const commonApiSlice = apiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchDepartments: builder.query({
      query: (params) => ({ url: "departments", params: params }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    fetchRequiredDetailsByRatingId: builder.query({
      query: (ratingId) => ({
        url: `common/ratingdetails/${ratingId}`,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    redirect: builder.query({
      query: (url) => ({
        url: `common/redirect`,
        method: "POST",
        body: { url },
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
})
export default commonApiSlice

export const {
  useLazyFetchDepartmentsQuery,
  useLazyFetchRequiredDetailsByRatingIdQuery,
  useLazyRedirectQuery,
} = commonApiSlice
